import React from 'react';
import PropTypes from 'prop-types';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import useModularPDPCustomerPhotosAndReviews from 'data-hooks/useModularPDPCustomerPhotosAndReviews';
import getRoundedRating from 'commons/getRoundedRating';
import useIsBrowser from 'hooks/useIsBrowser';

const ModularPDPRatingAndReviews = ({ onClick, href }) => {
  const isBrowser = useIsBrowser();
  const modularCustomerReviewsData = useModularPDPCustomerPhotosAndReviews();

  const {
    loading,
    customer_photos_min: { totalPhotos } = {},
    customer_reviews: { totalReviews, averageRating } = {},
  } = modularCustomerReviewsData || {};

  const roundedRating = getRoundedRating(averageRating);

  const hasData = totalPhotos !== undefined || totalReviews !== undefined;
  // Show loading state during SSR and initial hydration to prevent mismatch
  const isLoading = loading || !hasData || !isBrowser;

  return (
    <RatingAndReviews
      loading={isLoading}
      rating={roundedRating}
      numberOfReviews={(totalPhotos || 0) + (totalReviews || 0)}
      onClick={onClick}
      href={href}
    />
  );
};

ModularPDPRatingAndReviews.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
};

export default ModularPDPRatingAndReviews;
